<section fxFlex="1 1 auto" fxLayout="row">
    <section *ngIf="projectItemList" fxLayout="column" class="px-4 sen-project-items" fxFlex="1 1 auto">
        <div fxFlex="1 1 auto" class="pt-2 sen-item-list overflow-auto">
            <mat-accordion class="mx-5 d-block" [multi]="true">
                <mat-expansion-panel class="my-3">
                    <mat-expansion-panel-header class="sen-light-blue-bg">
                        <h5 title="{{selectedProjectArray.name}}"><b>{{translate.getLng('PROJECT')}}: {{selectedProjectArray.name | truncate:30}}</b>
                        </h5>
                    </mat-expansion-panel-header>
                    <sen-app-items-price [tableData]="projectItemList.projectItems"></sen-app-items-price>
                </mat-expansion-panel>
                <ng-container *ngFor="let plan of projectItemList.roofPlanItems">
                    <mat-expansion-panel *ngIf="plan.panelID != selectedProjectArray.panelID" class="my-3">
                        <mat-expansion-panel-header class="sen-light-blue-bg">
                            <h5 title="{{plan.name}}" class="mt-3">{{translate.getLng('ROOF_PLAN')}}: {{plan.name | truncate: 30}}</h5>
                        </mat-expansion-panel-header>
                        <sen-app-items-quantity [tableData]="plan"></sen-app-items-quantity>
                    </mat-expansion-panel>
                </ng-container>
                <mat-expansion-panel class="my-3">
                    <mat-expansion-panel-header class="sen-light-blue-bg">
                        <h5 class="mt-3">{{translate.getLng('INVERTER_AC_DC')}}</h5>
                    </mat-expansion-panel-header>
                    <sen-app-items-quantity [tableData]="projectItemList.inverterPlanItems"></sen-app-items-quantity>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="text-right">
            <button mat-raised-button color="primary" class="py-1 px-4 m-2" (click)="pdfExport()">
                <mat-icon>picture_as_pdf</mat-icon> {{translate.getLng('PDF_EXPORT')}}
            </button>
            <button mat-raised-button data-toggle="modal" data-target="#cartUrlModal" (click)="openCartModal()" color="primary" class="py-1">
                {{translate.getLng('GO_TO_SHOP')}}
            </button>
        </div>
    </section>

    <!-- Cart URL Modal -->
    <div
        class="modal fade"
        id="cartUrlModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="cartUrlModalLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
        cdkDrag
    >
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="row" style="padding: 10px 10px 0px" cdkDragHandle>
                    <div class="col-11">
                        <h5
                            class="modal-title pt-1 pl-2"
                            id="cartUrlModalLabel"
                            style="font-size: 18px"
                        >
                            {{ translate.getLng("GO_TO_SHOP") }}
                        </h5>
                    </div>
                    <div class="col-1">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body px-4 py-3">
                    <div class="form-group mb-3">
                        <label class="font-weight-bold" style="font-size: 14px;">
                            Select Shop Environment / URL:
                        </label>
                        <select
                            class="form-control"
                            [(ngModel)]="selectedCartUrlOption"
                            (change)="onSelectCartUrlOption()"
                        >
                            <option *ngFor="let option of cartUrlOptions" [value]="option.url">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group mb-0">
                        <label class="font-weight-bold" style="font-size: 14px;">
                            Cart / Shop URL:
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="cartUrl"
                            [disabled]="selectedCartUrlOption !== 'custom'"
                            placeholder="Please enter URL"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        [disabled]="!cartUrl || !cartUrl.trim()"
                        (click)="proceedToCart()"
                    >
                        Proceed
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
